import type { MessageDescriptor } from '@atlassian/jira-intl';
import messages from '../messages.tsx';

const ELIGIBLE_ISSUE_TYPES = ['bug', 'story', 'epic'];

const ELIGIBLE_ISSUE_TYPES_SET = new Set<string>(ELIGIBLE_ISSUE_TYPES);

export type SupportedIssueTypes = 'bug' | 'story' | 'epic';

export interface ConfluenceTemplate {
	name: MessageDescriptor;
	url: string;
	suggestedIssueType: string;
	blueprintModuleCompleteKey: string;
}

export const getConfluencePlaceholderTemplate = (
	issueType: string | undefined,
): ConfluenceTemplate | undefined => {
	const issueTypeName = issueType?.toLowerCase() || '';
	return confluencePlaceholderTemplates[issueTypeName];
};

export const isSupportedIssueType = (
	issueType: string | undefined,
): issueType is SupportedIssueTypes => {
	return ELIGIBLE_ISSUE_TYPES_SET.has(issueType?.toLowerCase() ?? '');
};

/**
 * The only issue types we are targeting for the Confluence Placeholder
 * Template experiment are 'story', 'epic', and 'bug'. Selected issue
 * type to template pairings are listed here:
 * https://hello.atlassian.net/wiki/spaces/ECON/pages/2768820121/Issue+type+template+pairing
 */
export const confluencePlaceholderTemplates: {
	[key: string]: ConfluenceTemplate;
} = {
	story: {
		name: messages.productRequirementsTemplateName,
		url: 'https://www.atlassian.com/software/confluence/templates/product-requirements',
		suggestedIssueType: 'story',
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
	},
	epic: {
		name: messages.projectPlanTemplateName,
		url: 'https://www.atlassian.com/software/confluence/templates/project-plan',
		suggestedIssueType: 'epic',
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
	},
	bug: {
		name: messages.knownErrorsTemplateName,
		url: 'https://www.atlassian.com/software/confluence/templates/itsm-known-errors',
		suggestedIssueType: 'bug',
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
	},
};
